import { render, staticRenderFns } from "./RoleBasedDashboard.vue?vue&type=template&id=214506ed&scoped=true&"
import script from "./RoleBasedDashboard.vue?vue&type=script&lang=js&"
export * from "./RoleBasedDashboard.vue?vue&type=script&lang=js&"
import style0 from "./RoleBasedDashboard.vue?vue&type=style&index=0&id=214506ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214506ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
